module.exports = __webpack_public_path__ + "static/media/sad-smile-chat-box.4d27f68d.svg";